"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.illustrations = void 0;

var confirm_email_1 = require("./confirm-email");

var error_1 = require("./error");

var expo_1 = require("./expo");

var networking_1 = require("./networking");

var success_1 = require("./success");

var ticket_types_1 = require("./ticket-types"); // All keys are wrapped in quotes for easier programmatic sorting
// prettier-ignore


exports.illustrations = {
  'confirm-email': confirm_email_1.ConfirmEmail,
  'error': error_1.Error,
  'expo': expo_1.Expo,
  'networking': networking_1.Networking,
  'success': success_1.Success,
  'ticket-types': ticket_types_1.TicketTypes
};